module.exports = __webpack_public_path__ + "static/media/icon-person.837ef98a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/sass/icons/icon-person.svg
// module id = 348
// module chunks = 0